import { styles } from './Quality.styles';

export const QualityLoading = () => (
	<>
		<header className={styles.topbar}>
			<div className="h-md w-[96px] animate-pulse rounded bg-grey-25" />
		</header>
		<main className={styles.content}>
			<div className="flex flex-col gap-xs">
				<div className="h-sm w-[128px] animate-pulse rounded bg-grey-25" />
				<div className="h-[28px] w-[192px] animate-pulse rounded bg-grey-25" />
				<div className="h-md w-[288px] animate-pulse rounded bg-grey-25" />
			</div>
			<div className={styles.kpiGrid}>
				{['a', 'b', 'c', 'd'].map((k) => (
					<div key={`quality-kpi-${k}`} className="h-[92px] animate-pulse rounded-lg bg-grey-25" />
				))}
			</div>
			<div className="h-[220px] animate-pulse rounded-lg bg-grey-25" />
		</main>
	</>
);

export const DailyReportsLoading = () => (
	<div className="flex flex-col gap-md">
		<div className={styles.reportsSkeletonTitle} />
		<div className={styles.scoreGrid}>
			<div className={styles.reportsSkeletonCard} />
			<div className={styles.reportsSkeletonCard} />
		</div>
		<div className={styles.reportsSkeletonTable} />
	</div>
);
